var angular = require('angular');

var util = require('js/lib/util');
var File = require('js/lib/file');
var customer = require('js/lib/customer');
var editCustomerTemplate = require('html/templates/editCustomer')();
var editCoordinatesTemplate = require('html/templates/editCoordinates')();
var t = require('js/lib/translate').t;

edit.$inject = ['$rootScope', '$timeout', '$document', 'load', '$filter', 'modal'];

function edit($rootScope, $timeout, $document, load, $filter, modal) {
  var self = this;

  this.openEditCustomer = function($scope, customer, cancelled, routeId) {
    $scope.isCollapsed = true;

    $scope.timePattern = /^([01][0-9]|2[0-3]):?[0-5][0-9]$/;

    $scope.editAddress = false; // Reset
    $scope.cancelled = cancelled;

    var focusOnInput = function() {
      $timeout(function() {
        if (focusSelector) {
          var item = $document[0].querySelector(focusSelector);
          item && item.focus();

        }
      });
    };

    var focusSelector;
    var route = $scope.routePlan.findRoute(routeId);

    if (customer) {
      // Existing customer
      $scope.activeCustomerId = customer.id;
      $scope.customer = customer.editClone();

      var stopLocation = customer.stopLocationId && $scope.routePlan.findStopLocation(routeId, customer.stopLocationId);
      $scope.changeHolder = {
        plan: $scope.routePlans.filter(function (routePlan) {
          return routePlan.id === $scope.routePlan.id;
        })[0],
        routes: $scope.routePlan.routes,
        selectedRoute: route,
        selectedStop: stopLocation,
        showStops: false
      };
      $scope.showMovePlan = true;
      $scope.receivedComingSms = customer.hasReceivedComingSms();
    } else {
      // New customer
      $scope.customer = {
        routePlanId: $scope.routePlan.id,
        editable: function() { return true; },
        deliveries: [{}]
      };
      if ($scope.routePlan.routes.length > 0) {
        // Plan has routes, force the user to choose route for new customer
        $scope.changeHolder = {
          routes: $scope.routePlan.routes,
          selectedRoute: route,
          selectedStop: null,
          showStops: false
        };
        $scope.isCollapsed = false;
        $scope.showMovePlan = true;
        $scope.receivedComingSms = false;
      }

      focusSelector = '.edit-customer select';
    }

    // Timestamp to human readable time
    $scope.customer.deliveryWindowStart = util.toTime($scope.customer.deliveryWindowStart);
    $scope.customer.deliveryWindowStop = util.toTime($scope.customer.deliveryWindowStop);

    $scope.enterEditAddressMode = function() {
      $scope.editAddress = true;
    };

    $scope.toggleMoveToPlanRoute = function() {
      $scope.isCollapsed = ! $scope.isCollapsed;
    };

    $scope.updateAddress = function(complete, address) {
      if (address) {
        angular.extend($scope.customer, address);
        self.toggleCoordinatesClass(false);
        $scope.$apply();
      }

      if (! focusSelector) {
        focusSelector = (complete && $scope.customer.latitude) ? 'input.name' : 'input.streetInput';
        focusOnInput();
      }
    };

    $scope.updateRouteList = function() {
      $scope.changeHolder.routes = [];
      if ($scope.changeHolder.plan && $scope.changeHolder.plan.id) {
        load.getPlanRoutes($scope.changeHolder.plan.id).then(function(routePlan) {
          $scope.changeHolder.routes = routePlan.routes;
        });
      }
      $scope.changeHolder.selectedStop = null;
    };

    $scope.routeChanged = function() {
      if ($scope.changeHolder.selectedRoute) {
        $scope.changeHolder.showStops = true;
        $scope.changeHolder.filteredStopLocations = $filter('receivedSms')($scope.changeHolder.selectedRoute.stopLocations);
        $scope.changeHolder.selectedStop = { id: 0 }; // Reset/default (if selecting first option)
      }
    };

    modal.open({
      scope: $scope,
      klass: 'edit-customer',
      title: t(customer ? 'customerModalHeaderEdit' : 'customerModalHeaderNew'),
      body: editCustomerTemplate,
      onClose: function() {
        $timeout(function() {
          $scope.activeCustomerId = null;
        });
      }
    });

    focusOnInput();
  };


  this.openMap = function($scope, event, customer) {
    var close = $scope._modal.close;

    // If the street is invalid, AH will force focus until the input is emptied.
    var blurStreetInput = function() {
      var streetContainer = angular.element($document[0].querySelector('.streetContainer .yui-ac-content'));
      var streetInput = angular.element($document[0].querySelector('.streetInput'));
      var street = streetInput.val();

      streetInput.val('');
      streetInput[0].blur();
      streetInput.val(street);
      streetContainer.css('display', 'none');
    };

    var importedCustomer = $scope.routePlan.findCustomer(customer.id);

    if (importedCustomer) {
      $scope.address = importedCustomer.fullAddress;
      $scope.city = importedCustomer.city; // For geocode fallback (omitting zip to rule out zip-changes)
    } else {
      // Customer is not yet added, just found through Address Helper, let pre-populate to better center map
      var streetElem = angular.element($document[0].querySelectorAll('.streetInput'));
      var streetNumberElem = angular.element($document[0].querySelectorAll('.streetNumberInput'));
      var cityElem = angular.element($document[0].querySelectorAll('.cityLabel'));
      if (streetElem && streetNumberElem && cityElem) {
        $scope.address = streetElem.val() + ' ' + streetNumberElem.val();
        $scope.city = cityElem.val();
      }
    }

    $scope.setCoordinates = function(latitude, longitude) {
      $scope.closeModal();

      customer.latitude = latitude;
      customer.longitude = longitude;

      self.toggleCoordinatesClass(!! latitude);
      if (latitude) blurStreetInput();
    };

    event.stopPropagation();
    event.preventDefault();

    modal.open({
      scope: $scope,
      title: $scope.address,
      klass: 'map-coordinates',
      body: editCoordinatesTemplate,
      onClose: function() {
        // Hack to restore the editCustomer modal's onClose
        $scope._modal.close = close;
      }
    });
  };


  var disableClose = function(event) {
    event.stopImmediatePropagation();
    event.preventDefault();
  };


  this.cancelDelivery = function($scope, event, deliveryId, customer) {
    customer.findDelivery(deliveryId).deliveryStatus = 11; // CANCELLED
    disableClose(event);
  };


  this.undoCancelDelivery = function($scope, event, deliveryId, customer) {
    customer.findDelivery(deliveryId).deliveryStatus = 0; // UNDELIVERED
    disableClose(event);
  };


  this.addDelivery = function(event, customer) {
    customer.deliveries.push({});
    disableClose(event);
  };


  this.deleteDelivery = function(event, index, customer) {
    customer.deliveries.splice(index, 1);
    if (! customer.deliveries.length) {
      customer.deliveries.push({});
    }
    disableClose(event);
  };

  this.deleteCustomer = function($scope, customer) {
    modal.open({
      scope: $scope,
      title: t('customerModalConfirmDeleteHeader'),
      body: t('customerModalConfirmDeleteBody'),
      onConfirm: function() {
        $scope.closeModal();
        load.deleteCustomer($scope, customer);
      },
      onClose: function() {
        $timeout(function() {  // force $apply
          $scope.activeCustomerId = null;
        });
      }
    });
  };

  this.cancelCustomer = function($scope, customer) {
    modal.open({
      scope: $scope,
      title: t('customerModalConfirmCancelHeader'),
      body: t('customerModalConfirmCancelBody'),
      onConfirm: function() {
        $scope.closeModal();
        load.cancelCustomer($scope, customer.id);
      },
      onClose: function() {
        $timeout(function() {  // force $apply
          $scope.activeCustomerId = null;
        });
      }
    });
  };

  this.toggleCoordinatesClass = function(on) {
    angular
      .element($document[0].getElementById('address-helper'))
      .toggleClass('manual-coordinates', on);
  };


  this.saveCustomer = function($scope, customer) {
    // Fallback (if AH is not used/filled out)
    customer.country = customer.country || $scope.routePlan.countryCode;
    customer.address = customer.address || 'Unknown address, use map';
    customer.zip = customer.zip || 1;
    customer.city = customer.city || '????';

    for (var prop in customer) {
      customer[prop] = customer[prop] || null;
    }

    customer.deliveries.forEach(function(delivery) {
      delivery.product = delivery.product || null;
    });

    customer.deliveries = customer.deliveries.filter(function(delivery) {
      return delivery.getStatus === undefined || delivery.getStatus() !== 'cancelled';
    });

    // Human readable time to timestamp
    customer.deliveryWindowStart = util.toDateWithTime($scope.routePlan.date, customer.deliveryWindowStart);
    customer.deliveryWindowStop = util.toDateWithTime($scope.routePlan.date, customer.deliveryWindowStop);

    customer.fileId = (customer.fileId === File.individual.id) ? null : customer.fileId;

    if (customer.description) {
      customer.description = customer.description.replace(/\n/g, '\\n');
    }

    if (! $scope.isCollapsed && $scope.changeHolder.selectedRoute != null) {

      var selectedPlanId = $scope.changeHolder.plan ? $scope.changeHolder.plan.id : customer.routePlanId;
      var selectedRouteId = $scope.changeHolder.selectedRoute.id;
      var selectedStopId = $scope.changeHolder.selectedStop ? $scope.changeHolder.selectedStop.id : 0; // Fallback: 0: Start of route

      // console.log('saveCustomer before', 'selectedStop', $scope.changeHolder.selectedStop, 'selectedStopId', selectedStopId);
      // console.log('saveCustomer', 'customer.stopLocationId', customer.stopLocationId, 'selectedStopId', selectedStopId);

      if ((customer.routePlanId != selectedPlanId) ||
          (customer.routeId != selectedRouteId) ||
          (customer.stopLocationId != selectedStopId) ) {
        customer.routePlanId = selectedPlanId;
        customer.routeId = selectedRouteId;
        customer.stopLocationId = selectedStopId;
      } else { // Cleanup for api if user has open the move to but not changed anything
        delete customer.routeId;
        delete customer.stopLocationId;
      }
    } else { // Cleanup for api if user has not opened move to
      delete customer.routeId;
      delete customer.stopLocationId;
    }

    // console.log('saveCustomer after', 'move?', !! customer.routeId, 'customer', customer);
    load.saveCustomer($scope, customer);
    $scope.closeModal();
  };

}

module.exports = edit;


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/services/editCustomer.js
 ** module id = 195
 ** module chunks = 1
 **/